<template>
  <section>
    <div v-if="edit" class="details">
      <div class="header">
        <input class="eventTitle" :style="title" v-model="title" />
        <div class="eventButtons">
          <div
            class="eventDelete"
            style="cursor: pointer"
            @click="toggleDelete()"
          ></div>
          <div
            class="eventSave"
            style="margin-left: 10px; cursor: pointer"
            @click="editDocument()"
          ></div>
          <div class="eventClose" @click="hideDetails()"></div>
        </div>
      </div>
      <div class="editHeader">
        <div class="activitySelect">
          <div
            @click="toggleActivity('class')"
            class="activityOption class"
            :style="this.type == 'class' ? { opacity: '1' } : {}"
          >
            Class
          </div>
          <div
            @click="toggleActivity('assessment')"
            class="activityOption assessment"
            :style="this.type == 'assessment' ? { opacity: '1' } : {}"
          >
            Assessment
          </div>
          <div
            @click="toggleActivity('assignment')"
            class="activityOption assignment"
            :style="this.type == 'assignment' ? { opacity: '1' } : {}"
          >
            Assignment
          </div>
          <div
            @click="toggleActivity('office')"
            class="activityOption office"
            :style="this.type == 'office' ? { opacity: '1' } : {}"
          >
            Office Hours
          </div>
          <div
            @click="toggleActivity('other')"
            class="activityOption other"
            :style="this.type == 'other' ? { opacity: '1' } : {}"
          >
            Other
          </div>
        </div>
        <div class="details">
          <input
            class="locationInput"
            v-model="location"
            type="text"
            placeholder="Location"
          />

          <textarea
            class="locationInput"
            v-model="description"
            type="text"
            placeholder="Description"
          />
        </div>
      </div>
    </div>
    <div v-else-if="deleteCheck" class="details">
      <p style="color: #a0a0a0; font-size: 12px">
        You are about to delete an event for all members of this group
      </p>
      <p></p>
      <div class="pointer" @click="deleteOneDocument()">Delete</div>
      <div class="pointer" @click="toggleDelete()">Cancel</div>
    </div>
    <div v-else-if="deleteRepeat" class="details">
      <div class="pointer" @click="deleteOneDocument()">Delete</div>
      <div class="pointer" @click="deleteRecurring()">
        Delete all recurring events
      </div>
      <div class="pointer" @click="toggleDelete()">Cancel</div>
    </div>
    <div v-else-if="editRepeat" class="details">
      <div class="pointer" @click="editOneDocument()">Only edit this event</div>
      <div class="pointer" @click="editRepeatDocument()">
        Edit all recurring events
      </div>
      <div class="pointer" @click="editDocument()">Cancel</div>
    </div>
    <div v-else class="details">
      <div class="header">
        <div class="flexRow">
          <div class="circleColour"></div>
          <p class="eventTitle" :style="title">{{ this.event.title }}</p>
        </div>
        <div class="eventButtons">
          <div
            class="eventDelete"
            style="cursor: pointer"
            @click="toggleDelete()"
          ></div>
          <div
            class="eventEdit"
            style="margin-left: 10px; cursor: pointer"
            @click="toggleEdit()"
          ></div>
          <div class="eventClose" @click="hideDetails()"></div>
        </div>
      </div>
      <div class="infoGrid">
        <div class="infoRow">
          <div class="timeIcon"></div>
          <p class="dateTitle" :style="style" v-if="event.isAllDay">
            {{ startDate }}: All Day
          </p>
          <p class="dateTitle" :style="style" v-else-if="endDate != ''">
            {{ startDate }} - {{ endDate }}
          </p>
          <p class="dateTitle" :style="style" v-else>
            {{ startDate }}: {{ startTime }} - {{ endTime }}
          </p>
        </div>
        <div v-if="this.event.repeatsString" class="infoRow">
          <div class="repeatIcon"></div>
          <p class="dateTitle" :style="style">{{ event.repeatsString }}</p>
        </div>
        <div v-if="this.event.location" class="infoRow">
          <div class="locationIcon"></div>
          <p class="dateTitle" :style="style" v-if="this.event.location">
            Location: {{ this.event.location }}
          </p>
        </div>
        <div v-if="this.event.description" class="infoRow">
          <div class="descriptionIcon"></div>
          <p class="dateTitle" :style="style" v-if="this.event.description">
            Description: {{ this.event.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/db";
import moment from "moment";

export default {
  props: ["event"],

  data: () => ({
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    edit: false,
    deleteCheck: false,
    editRepeat: false,
    deleteRepeat: false,
    title: "",
    type: "",
    locPlace: "",
    descPlace: "",
    location: "",
    description: "",
  }),
  computed: {
    style() {
      var color = "";
      switch (this.event.type) {
        case "class":
          color = "#16a085";
          break;
        case "assessment":
          color = "#e74c3c";
          break;
        case "assignment":
          color = "#f39c12";
          break;
        case "office":
          color = "#0984e3";
          break;
        case "other":
          color = "#a55eea";
          break;
      }
      return {
        color: color,
      };
    },
    titleStyle() {
      var color = "";
      switch (this.event.type) {
        case "class":
          color = "#16a085";
          break;
        case "assessment":
          color = "#e74c3c";
          break;
        case "assignment":
          color = "#f39c12";
          break;
        case "office":
          color = "#0984e3";
          break;
        case "other":
          color = "#a55eea";
          break;
      }
      return {
        "text-decoration": "underline " + color,
      };
    },
  },
  mounted() {
    this.title = this.event.title;
    this.type = this.event.type;
    this.location = this.event.location;
    this.description = this.event.description;
    this.startDate = moment(this.event.startDate).format("DD MMM YYYY");
    this.endDate = moment(this.event.endDate).format("DD MMM YYYY");
    if (this.endDate == this.startDate) {
      this.endDate = "";
    }
    this.startTime = moment(this.event.startDate).format("hh:mm a");
    this.endTime = moment(this.event.endDate).format("hh:mm a");
  },
  methods: {
    toggleDelete() {
      this.edit = false;
      if (this.event.repeatId == "") {
        this.deleteCheck = !this.deleteCheck;
      } else {
        this.deleteRepeat = !this.deleteRepeat;
      }
    },
    deleteDocument() {
      db.collection("calendarEvents")
        .doc(this.event.id)
        .delete();
    },
    deleteOneDocument() {
      db.collection("calendarEvents")
        .doc(this.event.id)
        .update({
          singleRepeatDelete: true,
        })
        .then(() => {
          db.collection("calendarEvents")
            .doc(this.event.id)
            .delete();
        });
    },
    deleteRecurring() {
      var repeatQuery = db
        .collection("calendarEvents")
        .where("repeatId", "==", this.event.repeatId);
      repeatQuery.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          db.collection("calendarEvents")
            .doc(doc.id)
            .delete();
        });
      });
    },
    toggleEdit() {
      this.edit = !this.edit;
    },
    editOneDocument() {
      this.hideDetails();
      db.collection("calendarEvents")
        .doc(this.event.id)
        .update({
          title: this.title,
          type: this.type,
          location: this.location,
          description: this.description,
          editAll: false,
        });
    },

    editRepeatDocument() {
      this.hideDetails();
      var repeatQuery = db
        .collection("calendarEvents")
        .where("repeatId", "==", this.event.repeatId);
      repeatQuery.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          db.collection("calendarEvents")
            .doc(doc.id)
            .update({
              title: this.title,
              type: this.type,
              location: this.location,
              description: this.description,
              editAll: true,
            });
        });
      });
    },

    editDocument() {
      if (this.event.repeatId == "") {
        this.hideDetails();
        db.collection("calendarEvents")
          .doc(this.event.id)
          .update({
            title: this.title,
            type: this.type,
            location: this.location,
            description: this.description,
            editAll: false,
          });
      } else {
        this.toggleEdit();
        this.editRepeat = !this.editRepeat;
      }
    },
    hideDetails() {
      this.event.showDetails = false;
    },
    toggleActivity(activity) {
      this.type = activity;
    },
  },
};
</script>

<style scoped>
p {
  color: black;
}

.pointer {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 0;
  white-space: nowrap;
}

.pointer:hover {
  color: #0fb9b1;
}

textarea {
  width: 90%;
  max-width: 90%;
  max-height: 30%;
}

.header {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.editHeader {
  display: flex;
  flex-direction: column;
}
.activitySelect {
  display: flex;
  flex-direction: row;
}
.circleColour {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin: 7px 13px;
  background: black;
}
.eventTitle {
  font-size: 20px;
  font-weight: normal;
  width: 150px;
  word-break: break-all;
  max-height: 30px;
  min-height: 30px;
  overflow: hidden;
}
.eventButtons {
  display: flex;
}
.dateTitle {
  color: black !important;
  font-size: 14px;
  margin-left: 5px;
}
.locationInput {
  font-size: 15px;
  color: black;
  margin-top: 5px;
  padding: 5px;
  max-width: 357px;
  min-width: 357px;
  border: thin solid #dfdfdf;
  outline: none;
  transition: ease-in-out 0.3s;
  border-radius: 5px;
  resize: none !important;
}
.details {
  max-width: 400px;
  min-width: 400px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  text-align: start;
  z-index: 30;
}
.infoGrid {
  display: flex;
  flex-direction: column;
}
.infoRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.timeIcon {
  background-image: url("../../assets/eventTime.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
}
.repeatIcon {
  background-image: url("../../assets/eventRepeat.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
}
.locationIcon {
  background-image: url("../../assets/eventLocation.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
}
.descriptionIcon {
  background-image: url("../../assets/eventDescription.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
}
.eventDelete {
  background-image: url("../../assets/eventDelete.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
  transition: ease-in-out 0.2s;
}
.eventDelete:hover {
  background-color: rgb(228, 228, 228);
}
.eventEdit {
  background-image: url("../../assets/eventEdit.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
  transition: ease-in-out 0.2s;
}
.eventEdit:hover {
  background-color: rgb(228, 228, 228);
}
.eventClose {
  background-image: url("../../assets/eventClose.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
  cursor: pointer;
  transition: ease-in-out 0.2s;
}
.eventClose:hover {
  background-color: rgb(228, 228, 228);
}
.eventSave {
  background-image: url("../../assets/eventSave.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  padding: 15px;
  margin: 5px;
  cursor: pointer;
  transition: ease-in-out 0.2s;
}
.eventSave:hover {
  background-color: rgb(228, 228, 228);
}
.location {
  width: 40%;
}

@keyframes slideBox {
  0% {
    left: 2.5%;
  }
  100% {
    left: 3%;
  }
}

.exit {
  width: 100%;
  height: 100%;
  font-size: 20px;
  width: 10px;
  transform: rotate(45deg);
  align-self: center;
  border-radius: 20vw;
  color: black;
  cursor: pointer;
  outline: none;
}
.activityOption {
  text-align: center;
  font-size: 13px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
  opacity: 0.2;
  cursor: pointer;
}
.activityOption:hover {
  opacity: 1;
}

.class {
  background-color: #16a085;
  color: #ffffff;
}
.assessment {
  background-color: #e74c3c;
  color: #ffffff;
}
.assignment {
  background-color: #f39c12;
  color: #ffffff;
}
.office {
  background-color: #0984e3;
  color: #ffffff;
}
.other {
  background-color: #a55eea;
  color: #ffffff;
}
</style>
